import { Badge, Group, HoverCard, Text } from "@mantine/core";
import type { DataTableColumn } from "mantine-datatable";
import { convertToDateTimeString } from "../../helpers/dates";
import { getFullName } from "../../helpers/stringHelper";
import { competenceCategoryTranslations } from "../../models/enums/competenceCategory";
import { impressionIcons } from "../../models/enums/impression";
import type { Observation } from "../../models/observation";
import { DataTable, type DataTableProps } from "../datatable/DataTable";

type ObservationTableProps = {
  observations: Observation[];
} & Required<
  Pick<
    DataTableProps<Observation>,
    "onEdit" | "onDelete" | "onSortStatusChange" | "sortStatus" | "pagination" | "onPageChange" | "fetching"
  >
>;

export function ObservationTable({ observations, ...props }: ObservationTableProps) {
  const createObservationPills = (observation: Observation) => (
    <Group>
      {observation.competence_categories.map((category) => (
        <Badge color="zli-grey" fw="600" variant="light" key={`${observation.id}.${category}`}>
          {competenceCategoryTranslations[category]}
        </Badge>
      ))}
    </Group>
  );

  const columns: DataTableColumn<Observation>[] = [
    {
      accessor: "created_by",
      title: "Erstellt von",
      sortable: true,
      render: (observation) => getFullName(observation.coach),
    },
    {
      accessor: "text",
      width: "25vw",
      render: (observation) => (
        <HoverCard width={400} shadow="md">
          <HoverCard.Target>
            <Text lineClamp={1}>{observation.text}</Text>
          </HoverCard.Target>
          <HoverCard.Dropdown>
            <Text size="sm">{observation.text}</Text>
          </HoverCard.Dropdown>
        </HoverCard>
      ),
    },
    {
      accessor: "competence_categories",
      title: "Kompetenzen",
      render: createObservationPills,
    },
    {
      accessor: "observed_at",
      sortKey: "observed_at",
      title: "Beobachtet am",
      sortable: true,
      render: (observation) => convertToDateTimeString(observation.observed_at),
    },
    {
      accessor: "impression",
      title: "Eindruck",
      width: "0%",
      textAlign: "center",
      render: (observation) => impressionIcons[observation.impression],
    },
  ];

  return <DataTable columns={columns} records={observations} {...props} />;
}
